import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";
import { formatApiErrorDetail } from "../lib/apiClient";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#0B101E]" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-[#D4AF37] mb-10" data-testid="back-to-login">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Reset password</div>
        <h1 className="font-display text-4xl mb-2">Forgot your password?</h1>
        <p className="text-white/60 text-sm mb-8">Enter your email and we'll send you a secure reset link valid for 1 hour.</p>

        {!sent ? (
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label className="text-xs uppercase tracking-widest text-white/50">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full bg-[#12182B] border border-white/10 rounded-md px-4 py-3 focus:outline-none focus:border-[#D4AF37]/60"
                data-testid="forgot-email-input" />
            </div>
            <button type="submit" disabled={loading} className="btn-gold w-full rounded-md py-3 disabled:opacity-60" data-testid="forgot-submit">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        ) : (
          <div className="bg-[#12182B] border border-[#D4AF37]/30 rounded-xl p-6 text-center" data-testid="forgot-sent">
            <div className="w-12 h-12 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/30 mx-auto flex items-center justify-center text-[#D4AF37]">
              <Mail className="w-5 h-5" />
            </div>
            <div className="font-display text-xl mt-4">Check your inbox</div>
            <p className="text-white/60 text-sm mt-3">If <span className="text-[#D4AF37]">{email}</span> is registered with us, a reset link is on its way.</p>
          </div>
        )}
      </div>
    </div>
  );
}
